// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"905ccd23","258":"723d27ee","261":"15b45c39","268":"4276bde6","377":"a2e45ab3","453":"b0d013df","487":"1c265c64","708":"676b7e95","817":"d00e66ad","845":"8b80459a","890":"f56adbc6","952":"5ed8689d","980":"7df88b30"}[chunkId] + ".chunk.js";
};